import { render, staticRenderFns } from "./ShopFavorite.vue?vue&type=template&id=32456183&scoped=true"
import script from "./ShopFavorite.vue?vue&type=script&lang=js"
export * from "./ShopFavorite.vue?vue&type=script&lang=js"
import style0 from "./ShopFavorite.vue?vue&type=style&index=0&id=32456183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32456183",
  null
  
)

export default component.exports